/*
 * @Author: 刘小博
 * @Date: 2023-02-27 16:54:13
 * @LastEditTime: 2023-02-27 17:06:01
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\utils\regex.js
 * 验证规则
 */
const RegEx = {
  mobile: /^((\(\d{3}\))|(\d{3}\-))?1\d{10}$/, //手机号校验
  mobileLenth: /^[0-9]{0,11}$/, //手机号长度符合校验
  email: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/, //邮箱校验
  alphabet: /^[a-z]+$/i, // 只能输入小写字母
  number: /^[0-9]+$/, // 只能输入0-9的数字
  float: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, // 两位小数
  float3: /^(([1-9][0-9]*)|(([0]\.\d{1,3}|[1-9][0-9]*\.\d{1,3})))$/, // 三位小数
  chinese: /^[\u4e00-\u9fa5]+$/, //只能输入中文
  trim: /^\S+(\s+\S+)*$/, //前后不允许输入空格
  customerCode: /^[a-z\d\.\-\_\(\)\（\）]+$/gi, //客户编码(数字、大小写字母、部分字符.-_()（）)
  creditCode: /^[0-9A-Za-z]{18}$/, //社会信用代码(请填写18位，数字或大小写英文字母)
  IDCard:
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, //身份证格式验证
  positiveInteger: /^[1-9]\d*$/, //正整数验证
}
export default RegEx
